module.exports = __webpack_public_path__ + "static/media/price_check.1026f535.svg";